import { useLiteStorefront } from '@client/hooks/use-lite-storefront';
import ReviewStars from '@client/pages/Storefront/containers/vendor_info/components/review_stars';
import { useAppSelector } from '@client/redux/hooks';
import { ClientOnly } from '@components/shared/ClientOnly';
import { selectIsMobile } from '@redux/viewport/selectors';
import { TextBody } from '@tkww/orion-web-ds-text';
import MoreOrLess from '@xo-union/tk-component-more-or-less';
import { format } from 'date-fns';
import React, { useMemo, type FC } from 'react';
import type { Size } from 'types/union/common';
import ACTIONS from '../../../../../constants';
import Styles from './GoogleReview.scss';
export interface OwnProps {
	authorName: string;
	publicProfilePicture: string;
	publishedAt: string;
	rating: number;
	reviewText: string;
}

type Props = OwnProps;

export const GoogleReview: FC<Props> = ({
	authorName,
	publicProfilePicture,
	publishedAt,
	rating,
	reviewText,
}) => {
	const reviewFormattedDate = format(new Date(publishedAt), 'M/dd/yy');
	const isMobile = useAppSelector(selectIsMobile);
	const isLiteStorefront = useLiteStorefront();

	const starSize: Size = useMemo(
		() => (isMobile || !isLiteStorefront ? 'sm' : 'md'),
		[isMobile, isLiteStorefront],
	);
	return (
		<div className={Styles.googleReview}>
			<div className={Styles.header}>
				<div className={Styles.authorInfo}>
					<div className={Styles.authorImage}>
						<img src={publicProfilePicture} alt={authorName} />
					</div>
					<TextBody size="sm" bold className={Styles.authorName}>
						{authorName}
						<div className={Styles.reviewRating}>
							<ReviewStars
								overallRating={rating}
								size={starSize}
								wrapperClass={Styles.starsWrapper}
							/>
							<span className={Styles.rating}>{rating.toFixed(1)}</span>
						</div>
					</TextBody>
				</div>
				<ClientOnly>
					<TextBody size="sm" className={Styles.reviewDate}>
						{reviewFormattedDate}
					</TextBody>
				</ClientOnly>
			</div>
			<div className={Styles.content}>
				<MoreOrLess
					content={reviewText}
					charLimit={ACTIONS.GOOGLE_REVIEW_MORE_OR_LESS_CHAR_LIMIT}
				/>
			</div>
		</div>
	);
};
